import { createStyles, withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
const FTLStyledTableRowComponent = withStyles((theme) => createStyles({
    root: {
        '&:nth-of-type(odd)': {},
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            cursor: 'pointer'
        }
    },
}))(TableRow);
export default FTLStyledTableRowComponent;
//# sourceMappingURL=FTLStyledTableRowComponent.js.map